import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaUserTag,
  FaVenusMars,
  FaCircle,
} from "react-icons/fa";
import { viewStaffApi } from "../../api/staffService";
import { getErrorMessage } from "../../utils/errorHandler";
import StatusBadge from "../Shared/StatusBadge";
import RecordActions from "../Shared/RecordActions";
import FullPageLoader from "../../common/FullPageLoader";
export default function ViewStaff() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const staffId = params?.staffId || location?.state?.staffId;
  const [staff, setStaff] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!staffId) {
      setLoading(false);
      return;
    }
    const fetchStaff = async () => {
      try {
        setLoading(true);
        const response = await viewStaffApi(staffId);
        setStaff(response?.data || response);
      } catch (err) {
        setError(getErrorMessage(err));
      } finally {
        setLoading(false);
      }
    };
    fetchStaff();
  }, [staffId]);
  if (loading) {
    return <FullPageLoader text="Loading staff..." />;
  }
  if (error) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }
  if (!staff) {
    return (
      <div className="container mt-4">
        <div className="card">
          <div className="card-body text-center py-4">Staff not found</div>
        </div>
      </div>
    );
  }
  return (
    <div className="container mt-4">
      <RecordActions
        onBack={() => navigate("/staff")}
        onEdit={() =>
          navigate(`/staff/edit/${staffId}`, {
            state: { staffId, userId: location?.state?.userId },
          })
        }
      />
      <div className="card p-3">
        <div className="row g-3">
          <div className="col-md-4 mb-2 d-flex align-items-center gap-2">
            <FaUser className="text-muted" aria-hidden="true" />
            <span>{staff?.fullName || "N/A"}</span>
          </div>
          <div className="col-md-4 mb-2 d-flex align-items-center gap-2">
            <FaEnvelope className="text-muted" aria-hidden="true" />
            <span>{staff?.email || "N/A"}</span>
          </div>
          <div className="col-md-4 mb-2 d-flex align-items-center gap-2">
            <FaPhone className="text-muted" aria-hidden="true" />
            <span>{staff?.mobileCountryCode || "N/A"}</span>
          </div>
          <div className="col-md-4 mb-2 d-flex align-items-center gap-2">
            <FaUserTag className="text-muted" aria-hidden="true" />
            <span>{staff?.role || "N/A"}</span>
          </div>
          <div className="col-md-4 mb-2 d-flex align-items-center gap-2">
            <FaVenusMars className="text-muted" aria-hidden="true" />
            <span>{staff?.gender || "N/A"}</span>
          </div>
          <div className="col-md-4 mb-2 d-flex align-items-center gap-2">
            <FaCircle className="text-muted" aria-hidden="true" />
            <StatusBadge status={staff?.status} />
          </div>
        </div>
      </div>
    </div>
  );
}
